import React, { useState } from 'react';
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';

const QrEvents = () => {
    return (
        <div>
            <Navbar />

            <div style={{ textAlign: 'center' }}>
          
            </div>
        
        </div >

    );

};


export default QrEvents;